import { Collection, MultilineInput } from "@tblabs/truffle";
import { MarkdownField } from "../../../Models/Description/Markdown/MarkdownField";
import { Field } from "../../../Models/Description/Field";
import { FieldEditor } from "../../Utils/FieldEditor";
import { Markdown } from "../../Utils/Markdown";
import { Tab } from "../../../Models/Product/Tab";
import { Row } from "../../Utils/Row";
import { FormRow } from "../../../Pages/Product/InputsPrinter";


export class MarkdownEditor extends FieldEditor
{
    constructor(description: MarkdownField, descriptions: Collection<Field>, tabs: Collection<Tab>)
    {
        super("Markdown", description, descriptions, tabs, [
            new FormRow("Treść",
                new Row(
                    new MultilineInput(description.Markdown).Rows(12).Placeholder("Treść (jako Markdown)").Class("markdown-edit"),
                    new Markdown(description.Markdown).Class("markdown-edit-preview"),
                ))
        ]);
    }
}
